 import React from "react";
 import Stepper from "@techsoftware/happay-widgets/Stepper";
 import Grid from "@techsoftware/happay-widgets/Grid";
 import PropTypes from "prop-types";
 
 export default function BulkAdditionStepper(props) {
     function _populateStepperData() {
         const { stepNo, stepStatus } = props;
         return [
             {
                 content: <div className="ht-stepper-label padding-l-20 primary-dark-color fw-600">Upload File</div>,
                 active: stepNo === 1 ? true : false,
                 icon: stepNo === 2 || stepNo === 3 ? "tick-fill" : "",
                 lineColor: stepNo === 1 && "#d8d8d8",
                 borderType: "dashed"
             },
             {
                 content: (
                     <div
                         className="ht-stepper-label padding-l-22 primary-dark-color fw-600"
                        //  style={{ color: stepNo !== 2 || stepNo !== 3 ? "#3c424e" : null }}
                     >
                         Preview File
                     </div>
                 ),
                 active: stepNo === 2 ? true : false,
                 icon: stepNo === 3 ? "tick-fill" : "",
                 lineColor: stepNo !== 3 && "#d8d8d8",
                 borderType: "dashed"
             },
             {
                 content: (
                     <div
                         className="ht-stepper-label padding-l-20 primary-dark-color fw-600"
                        //  style={{ color: stepNo !== 2 ? "#3c424e" : null }}
                     >
                         Submit
                     </div>
                 ),
                 active: stepNo === 3 ? true : false,
                 icon: stepNo === 3 ? (stepStatus === "success" ? "tick-fill" : "cross-fill") : ""
             }
         ];
     }

     return (
         <Grid item xs={24} sm={24} md={24} lg={24} xl={24}>
                 <Stepper type="horizontal" data={_populateStepperData()} stepperId="horizontal" />
         </Grid>
     );
 }
 
 BulkAdditionStepper.propTypes = {
     stepNo: PropTypes.number,
     stepStatus: PropTypes.string,
 };
 
 BulkAdditionStepper.defaultProps = {
     stepNo: 1,
     stepStatus: '',
 };
 
